import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import classnames from 'classnames2';
import React from 'react';
import { useSelectContext } from '../useSelectContext';
import styles from './Select.List.scss';
export var SelectList = function SelectList(_ref) {
  var hasFooter = _ref.hasFooter,
      width = _ref.width,
      height = _ref.height,
      props = _objectWithoutProperties(_ref, ["hasFooter", "width", "height"]);

  var _useSelectContext = useSelectContext(),
      popper = _useSelectContext.popper,
      focusedIndex = _useSelectContext.focusedIndex,
      setFocusedIndex = _useSelectContext.setFocusedIndex,
      isOpen = _useSelectContext.isOpen,
      onOpen = _useSelectContext.onOpen,
      onClose = _useSelectContext.onClose,
      focusableItems = _useSelectContext.focusableItems,
      menuId = _useSelectContext.menuId,
      buttonId = _useSelectContext.buttonId,
      hasParentMenu = _useSelectContext.hasParentMenu,
      reference = _useSelectContext.reference,
      menuRef = _useSelectContext.menuRef;

  var handleKeyDown = function handleKeyDown(event) {
    var count = focusableItems.current.length;
    var nextIndex;

    if (event.key === 'ArrowDown') {
      event.preventDefault();
      event.stopPropagation(); // tslint:disable-next-line

      nextIndex = (focusedIndex + 1) % count;
      setFocusedIndex(nextIndex);
    } else if (event.key === 'ArrowUp') {
      event.preventDefault();
      event.stopPropagation(); // tslint:disable-next-line

      nextIndex = (focusedIndex - 1 + count) % count;
      setFocusedIndex(nextIndex);
    } else if (event.key === 'ArrowLeft') {
      event.preventDefault();
      event.stopPropagation();

      if (hasParentMenu) {
        onClose();

        if (reference.ref.current) {
          reference.ref.current.focus();
        }
      }
    } else if (event.key === 'Tab') {
      if (event.shiftKey) {
        event.preventDefault();
        onClose();
      }
    } else if (event.key === 'Escape') {
      onClose();
    }
  };

  var onMouseEnter = function onMouseEnter() {
    // If we're in a nested menu, keep the menu open when we mouse into it
    if (hasParentMenu) {
      onOpen();
    }
  };

  var onMouseLeave = function onMouseLeave() {
    if (hasParentMenu) {
      onClose();
    }
  };

  var menuWidthStyle = function menuWidthStyle() {
    switch (width) {
      case 'full':
        return styles.fullContainerWidth;

      default:
        return styles.defaultMenuWidth;
    }
  };

  var handleBlur = function handleBlur(event) {
    var target = event.relatedTarget || document.activeElement;
    var isWithinSelf = false;

    if (popper.ref.current) {
      isWithinSelf = popper.ref.current.contains(target);
    }

    if (!isWithinSelf && !hasParentMenu) {
      onClose();
    }
  };

  if (!isOpen) return null;
  return React.createElement("div", {
    role: "listbox",
    className: classnames(styles.menu, menuWidthStyle(), hasFooter && styles.withFooter),
    ref: menuRef,
    id: menuId,
    "aria-labelledby": buttonId,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    onKeyDown: handleKeyDown,
    onBlur: handleBlur,
    tabIndex: -1,
    style: _objectSpread(_objectSpread({}, popper.style), {
      maxHeight: height
    })
  }, props.children);
};
SelectList.displayName = 'Select.List';